import axios from '../../axios';
import * as types from './mutation-types'
const state = () => ({
	categories: ''
})
const actions = {
	fetchCategories({ commit }) {
		return axios.get('/categories').then(response => commit(types.STORE_CATEGORIES, response.data))
	}
}
const mutations = {
	[types.STORE_CATEGORIES](state, data) {
		state.categories = data;
	}
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
